import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import PdfViewer from './components/PdfViewer';
import Grade6Page from './pages/Grade6Page';
import Grade9Page from './pages/Grade9Page';
import Grade10Page from './pages/Grade10Page';
import Grade11Page from './pages/Grade11Page';
import Grade12Page from './pages/Grade12Page';
import AboutPage from './pages/AboutPage';
import FAQPage from './pages/FAQPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import SchemeOfWork from './pages/SchemeOfWork';
import Service from './pages/Service';
import SimpleLinkHubItem from './pages/SimpleLinkHubItem';
import NewsStoryPage from './pages/NewsStoryPage'; // Add this import
import './App.css';

// Scroll to content after hero section
function ScrollAfterHero() {
  const { pathname } = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      // Calculate scroll position (adjust based on your layout)
      const navbarHeight = 80; // Adjust based on your navbar height
      const heroHeight = 600; // Adjust based on your hero section height
      
      window.scrollTo({
        top: navbarHeight + heroHeight, // Start of content after hero
        left: 0,
        behavior: 'smooth'
      });
    }, 100);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollAfterHero />
        
        <Routes>
          {/* All regular routes use Layout */}
          <Route path="/" element={
            <Layout>
              <HomePage />
            </Layout>
          } />
          <Route path="/grade6" element={
            <Layout>
              <Grade6Page />
            </Layout>
          } />
          <Route path="/grade9" element={
            <Layout>
              <Grade9Page />
            </Layout>
          } />
          <Route path="/grade10" element={
            <Layout>
              <Grade10Page />
            </Layout>
          } />
          <Route path="/grade11" element={
            <Layout>
              <Grade11Page />
            </Layout>
          } />
          <Route path="/grade12" element={
            <Layout>
              <Grade12Page />
            </Layout>
          } />
          
          {/* New informational pages */}
          <Route path="/about" element={
            <Layout>
              <AboutPage />
            </Layout>
          } />
          <Route path="/faq" element={
            <Layout>
              <FAQPage />
            </Layout>
          } />
          <Route path="/privacy" element={
            <Layout>
              <PrivacyPolicyPage />
            </Layout>
          } />
          <Route path="/terms" element={
            <Layout>
              <TermsOfServicePage />
            </Layout>
          } />
          
          {/* Scheme of Work page */}
          <Route path="/scheme-of-work" element={
            <Layout>
              <SchemeOfWork />
            </Layout>
          } />
          
          {/* Services page */}
          <Route path="/services" element={
            <Layout>
              <Service />
            </Layout>
          } />
          
          {/* Link Hub Item pages */}
          <Route path="/link-hub/:linkId" element={
            <Layout>
              <SimpleLinkHubItem />
            </Layout>
          } />
          
          {/* News Story page */}
          <Route path="/news/:id" element={
            <Layout>
              <NewsStoryPage />
            </Layout>
          } />
          
          {/* PDF viewer route without Layout */}
          <Route path="/pdf-viewer/:filename" element={<PdfViewer />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;